import React, { useState } from "react";
import { Navigate, NavLink, useNavigate } from "react-router-dom";

export default function Book() {
  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");
  const [differenceInDays, setDifferenceInDays] = useState(0);
  // Function to calculate the difference in days
  const navigate = useNavigate();
  const calculateDateDifference = (checkIn, checkOut) => {
    if (checkIn && checkOut) {
      const checkInDateObj = new Date(checkIn);
      const checkOutDateObj = new Date(checkOut);

      // Difference in milliseconds
      const differenceInMs = checkOutDateObj - checkInDateObj;

      // Convert milliseconds to days
      const daysDifference = differenceInMs / (1000 * 60 * 60 * 24);

      setDifferenceInDays(daysDifference);
    }
  };
  const storeDataIntoLocal = (event) => {
    event.preventDefault();

    // ;
    const storageData = {
      chaekIn: event.target.chekindate.value,
      chaekOut: event.target.chackoutdate.value,
      adults: event.target.adults.value,
      child: event.target.child.value,
      nights: differenceInDays,
    };
    console.log(storageData);
    // localStorage.setItem(storageData);
    sessionStorage.setItem("bookingDetails", JSON.stringify(storageData));
    // sessionStorage.setItem("nights", differenceInDays);
    navigate("rooms");
  };
  return (
    <>
      <div
        className="container-fluid booking pb-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container">
          <div className="bg-white shadow" style={{ padding: "35px" }}>
            <form onSubmit={storeDataIntoLocal}>
              <div className="row g-2">
                <div className="col-md-10">
                  <div className="row g-2">
                    <div className="col-md-3">
                      <div
                        className="date"
                        id="date1"
                        data-target-input="nearest"
                      >
                        <input
                          type="date"
                          className="form-control"
                          id="chekindate"
                          name="chekindate"
                          required
                          min={new Date().toISOString().split("T")[0]} // Disable past dates
                          value={checkInDate}
                          onChange={(e) => {
                            setCheckInDate(e.target.value);
                            calculateDateDifference(
                              e.target.value,
                              checkOutDate
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div
                        className="date"
                        id="date2"
                        data-target-input="nearest"
                      >
                        <input
                          type="date"
                          className="form-control"
                          id="checkout"
                          name="chackoutdate"
                          required
                          min={
                            checkInDate ||
                            new Date().toISOString().split("T")[0]
                          } // Disable dates before check-in
                          value={checkOutDate}
                          onChange={(e) => {
                            setCheckOutDate(e.target.value);
                            calculateDateDifference(
                              checkInDate,
                              e.target.value
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <input
                        type="text"
                        name="adults"
                        className="form-control"
                        placeholder="Number of Adults"
                        aria-describedby="btnGroupAddon2"
                        maxLength="2"
                        onInput={(e) =>
                          (e.target.value = e.target.value
                            .replace(/[^0-9]/g, "")
                            .slice(0, 6))
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <input
                        name="child"
                        type="text"
                        className="form-control"
                        placeholder="Number of Child"
                        aria-describedby="btnGroupAddon2"
                        maxLength="2"
                        onInput={(e) =>
                          (e.target.value = e.target.value
                            .replace(/[^0-9]/g, "")
                            .slice(0, 6))
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-2">
                  {/* <NavLink to={"contact"}> */}
                  <button
                    type="submit"
                    className="btn btn-primary-custom w-100"
                  >
                    Submit
                  </button>
                  {/* </NavLink> */}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
